
type Feature = {
  title: string;
  description: string;
  image: string;
};

type FeaturesSectionProps = {
  features: Feature[];
};

const SmallScreenFeatures: React.FC<FeaturesSectionProps> = ({ features }) => (
  <div className="bg-[#F5F7FA] pb-1 pt-[64px] md:pt-[120px] px-6 max-w-[480px] mx-auto">
    <div className="mb-10">
      <p className="font-inter font-semibold text-[16px] leading-[150%] tracking-[-0.005em] text-[#42B7B1] mb-1">Key features //</p>
      <h2 className="font-utility font-[500] text-[30px] leading-[130%] tracking-[-0.01em] text-[#011621]">What Sets Us Apart</h2>
    </div>

    {features.map((feature, index) => (
      <div key={index} className="mb-10">
        <h3 className="font-utility font-[500] text-[24px] text-[#011621] mb-4">{feature.title}</h3>
        <div className="w-full mb-4 overflow-hidden ">
          <img
            src={feature.image}
            alt={feature.title}
            className="w-full h-full max-h-[184px]  max-w-[328px] object-cover"
          />
        </div>
        <p className="text-[16px] leading-[150%] text-[#011621] font-normal">{feature.description}</p>
      </div>
    ))}
  </div>
);

export default SmallScreenFeatures;
